import HexController from 'controllers/hex_controller';
import { el } from 'modules/DOM';
import Tribute from 'tributejs';

export default class extends HexController {
  static targets = ['textarea'];

  static values = {
    parameters: {
      type: Array,
      default: []
    }
  }

  static outlets = ['ms--parameters-dropdown'];

  _tribute = null;
  _usedParametersList = [];

  connect() {
    this.setupTribute()
    this._updateUsedParameters();
    this.element.addEventListener('input', () => {
      this._updateUsedParameters();
    });
  }

  disconnect() {
    this.removeTribute();
    this.removeMenuContainer();
  }

  _updateUsedParameters(selectedParameter = null) {
    this._usedParametersList = this.parametersValue.filter(p => {
      // Return true if it's the currently selected parameter
      if (p.name === selectedParameter) return true;
      // Return true if it's used in any of the textarea targets
      return this.msParametersDropdownOutlets.find(outlet => outlet.textareaTargets.find(el => el.value.includes(`<${p.name}>`)));
    }).map(p => p.name);
  }

  appendMenuContainer() {
    const menuContainer = el('div.dropdown-element');
    this.element.append(menuContainer);
    return menuContainer;
  }

  removeMenuContainer() {
    const menuContainer = this.element.querySelector('.dropdown-element');
    if (menuContainer) {
      this.element.removeChild(menuContainer);
    }
  }

  get menuContainer() {
    let menuContainer = this.element.querySelector('.dropdown-element');
    if (!menuContainer) {
      menuContainer = this.appendMenuContainer();
    }
    return menuContainer;
  }

  setupTribute() {
    if (!this._tribute) {
      // If user enters a `<` character, show the dropdown
      this._tribute = new Tribute({
        menuContainer: this.menuContainer,
        itemClass: 'dropdown-item',
        trigger: '<',
        values: this.parametersValue,
        lookup: 'name',
        fillAttr: 'name',
        selectTemplate: (item) => {
          if (typeof item === "undefined") return null;
          this._updateUsedParameters(item.original.name);
          return `<${item.original.name}>`;
        },
        // template for displaying item in menu
        menuItemTemplate: (item) => {
          return `<span class='parameter-name ${this._usedParametersList.includes(item.original.name) ? 'used-parameter' : ''}'>${item.string}</span>`;
        },
        noMatchTemplate: () => {
          return ``;
        },
        allowSpaces: true
      });
    }
    this.textareaTargets.forEach(el => {
      this._tribute.attach(el);
    });
  }

  removeTribute() {
    if (this._tribute) {
      this.textareaTargets.forEach(el => {
        this._tribute.detach(el);
      });
    }
  }

  parametersValueChanged() {
    // Replace all the items in the Tribute collection with the new ones
    if (this._tribute) {
      this._tribute.append(0, this.parametersValue, true);
    }
  }
}
